<div fxLayout="row" [ngClass]="{'id-table-class': isTable}" fxLayoutAlign="center center" *ngIf="id">
    <!-- <div matTooltip="{{id}}">{{ getSplitId() }}</div> -->
    <button mat-icon-button [color]="buttonColor" (click)="loadModal()"
        matTooltip="{{ 'COMMON.EXTERNAL_INTERACTIONS' | transloco }}" [matTooltipPosition]="'above'">
        <mat-icon class="s-20">open_in_new</mat-icon>
    </button>
</div>
